import DataCheck from './DataCheck';

export default DataCheck;
